import * as Yup from 'yup';
import { CREDENTIAL_TYPE } from '../constants/personCredentialFormConstants';

const personCredentialSchema = Yup.object({
  Type: Yup.string().nullable().required('Type is required'),

  Number: Yup.string()
    .nullable()
    .required('Number is required')
    .max(50, 'Number cannot exceed 50 characters')
    .when('Type', {
      is: CREDENTIAL_TYPE.SSN,
      then: (schema) =>
        schema.test('ssn-length', 'SSN value cannot be less than 9 digits', (value) => {
          if (!value) return true;
          return value.replace(/-/g, '').length >= 9;
        }),
    }),

  Expiration: Yup.date()
    .nullable()
    .test('date-range', 'Expiration date must be on or after the Issued date', function (value) {
      const { Issued } = this.parent;
      if (!value || !Issued) return true;
      return new Date(value) >= new Date(Issued);
    }),

  Description: Yup.string().nullable().max(2000, 'Description cannot exceed 2000 characters'),

  Notes: Yup.string().nullable().max(2000, 'Notes cannot exceed 2000 characters'),
});

export default personCredentialSchema;
